module.exports = __webpack_public_path__ + "img/deskshelf20.8a2f0115.jpg";